import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

const ContractorOperatorsField = ({ record }) => {
    if (!record) return null;

    if (!record.operators || record.operators.length === 0) {
        return (
            <Typography variant='body2' className='gray'>
                —
            </Typography>
        );
    }

    return record.operators.sort().join(', ');
};

ContractorOperatorsField.propTypes = {
    record: PropTypes.shape({
        operators: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
};

export default ContractorOperatorsField;
